"use client"

import { ccm19Show } from "src/integrations/ccm19/api"

export const CookieSettingsButton = () => {
  return (
    <button type="button" onClick={ccm19Show} className="p-4 hover:underline">
      Cookie-Einstellungen
    </button>
  )
}
